/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const teamMembersSearchFiltersSchema = z.object({
  locationIds: z.array(z.int()).nullish(),
  query: z.string().nullish(),
  resourceStatus: z.enum(['ACTIVE', 'DEACTIVATED']).nullish(),
  roleIds: z.array(z.int()).nullish(),
  showFutureMemberships: z.boolean(),
  showPastMemberships: z.boolean(),
  skillIds: z.array(z.int()).nullish(),
});
